import React from 'react';
import { MapPin } from 'lucide-react';

const PropertyDetailsCard = ({ roofData }) => {
  if (!roofData) return null;

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl shadow-sm p-6 mb-8 border border-blue-100">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-bold text-gray-900 flex items-center">
          <MapPin className="w-5 h-5 text-blue-600 mr-2" />
          Property Details
        </h3>
        <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full">
          {roofData.confidence} Confidence
        </span>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-white rounded-xl p-4">
          <div className="text-sm text-gray-600 mb-1">Property Address</div>
          <div className="font-semibold text-gray-900 text-sm leading-tight">
            {roofData.address}
          </div>
        </div>
        <div className="bg-white rounded-xl p-4">
          <div className="text-sm text-gray-600 mb-1">Total Roof Area</div>
          <div className="font-bold text-2xl text-blue-600">
            {roofData.totalArea}
          </div>
        </div>
        <div className="bg-white rounded-xl p-4">
          <div className="text-sm text-gray-600 mb-1">Roof Type</div>
          <div className="font-semibold text-gray-900">{roofData.roofType}</div>
          <div className="text-xs text-gray-500 mt-1">
            {roofData.detectionMethod}
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4 mt-4">
        <div className="bg-white rounded-xl p-4">
          <div className="text-sm text-gray-600 mb-1">Pitched Area</div>
          <div className="font-semibold text-gray-900">
            {roofData.pitchedArea}
          </div>
        </div>
        <div className="bg-white rounded-xl p-4">
          <div className="text-sm text-gray-600 mb-1">Flat Area</div>
          <div className="font-semibold text-gray-900">{roofData.flatArea}</div>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetailsCard;
